import { render } from "./ForgotPassword.vue?vue&type=template&id=c5e946e8"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=c5e946e8&lang=scss"

import exportComponent from "C:\\Users\\oscar\\Documents\\GitHub\\ReSeT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__